module.exports = __webpack_public_path__ + "static/media/Artboard9.000d6521.svg";